var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import { useState } from "react";
import { DatePicker } from "../../../../../Atoms";
import { ClearApplyButtons } from "../../../../../Common";
export function DateFilter(_a) {
    var values = _a.values, onClear = _a.onClear, onSubmit = _a.onSubmit, _b = _a.fieldName, fieldName = _b === void 0 ? "date" : _b;
    var initialValue = (values === null || values === void 0 ? void 0 : values[fieldName]) || null;
    var _c = __read(useState(initialValue), 2), date = _c[0], setDate = _c[1];
    var handleSubmit = function () {
        var _a;
        if (date) {
            onSubmit((_a = {},
                _a[fieldName] = date,
                _a));
        }
    };
    var handleDateChange = function (date) {
        setDate(date);
    };
    return (_jsxs(Stack, { children: [_jsx(DatePicker, { dateFieldProps: { onChange: handleDateChange, value: date } }), _jsx(ClearApplyButtons, { handleSubmit: handleSubmit, onClear: onClear })] }));
}
export default DateFilter;
